export const EntraPrefix = {
    FACILITY: "ERT_Facility",
};
